const FEATURE_CALENDAR = 'CALENDAR' as const;
const FEATURE_CONTACTS = 'CONTACTS' as const;
const FEATURE_CONTACT_TODAY = 'CONTACT_TODAY' as const;
const FEATURE_DELIVERED_RESPONSE_TODAY = 'DELIVERED_RESPONSE_TODAY' as const;
const FEATURE_EXCLUSION = 'EXCLUSIONS' as const;
const FEATURE_EXPORT = 'EXPORT' as const;
const FEATURE_STATISTICS = 'STATISTICS' as const;

export const Features = {
  [FEATURE_CALENDAR]: FEATURE_CALENDAR,
  [FEATURE_CONTACTS]: FEATURE_CONTACTS,
  [FEATURE_CONTACT_TODAY]: FEATURE_CONTACT_TODAY,
  [FEATURE_DELIVERED_RESPONSE_TODAY]: FEATURE_DELIVERED_RESPONSE_TODAY,
  [FEATURE_EXCLUSION]: FEATURE_EXCLUSION,
  [FEATURE_EXPORT]: FEATURE_EXPORT,
  [FEATURE_STATISTICS]: FEATURE_STATISTICS,
};

export type Features = keyof typeof Features;
